module.exports = __webpack_public_path__ + "img/ic_supply_chain.7203e0d6.png";